<template>
  <div>
    <div class="row">
      <div class="col-xs-12">
        <h3>Filtros ativos</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 lista-cards">
        <a
          role="button"
          v-for="secr in secretarias"
          :title="secr.titulo"
          :data-toggle="'popover'"
          :data-content="secr.objetivo"
          :data-trigger="'hover'"
          :key="secr.codigo"
          @click="$emit('click', secr)"
        >
          <span>
            {{ secr.sigla }}
          </span>
          <font-awesome-icon :icon="'times'" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    secretarias: {
      type: Array,
      required: true
    }
  },
  mounted() {
    this.triggerPopover()
  },
  updated() {
    this.triggerPopover()
  },
  methods: {
    triggerPopover() {
      window.jQuery('[data-toggle="popover"]').popover({})
    }
  }
}
</script>

<style scoped>
.lista-cards {
  display: flex;
  gap: 5px;
  margin: 15px 0;
  flex-wrap: wrap;
}
.lista-cards > a {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  /* color: #0d291b; */
  /* background-color: #e1e1e1; */
  border: 1px solid #468b35;
  padding: 5px 10px;
  border-radius: 15px / 20px;
  min-width: 100px;
}
.lista-cards > a:hover {
  border-color: #a1be4d;
}
</style>



// WEBPACK FOOTER //
// src/components/Dados/CardsFiltrosSecretaria.vue